import { render, staticRenderFns } from "./ModificacionManual.vue?vue&type=template&id=5c614850"
import script from "./ModificacionManual.vue?vue&type=script&lang=js"
export * from "./ModificacionManual.vue?vue&type=script&lang=js"
import style0 from "./ModificacionManual.vue?vue&type=style&index=0&id=5c614850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports